import React, { useEffect, useState } from "react";
import styles from "./ApplicationCenterMain.module.css";
import eva from "../../../assets/images/eva.svg";
import circle from "../../../assets/images/circle.svg";
import { Link, useHistory, useParams } from "react-router-dom";
import { ApplicationByIdApi } from "../../../config/ApplicationByIdApi";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";

function ApplicationCenterMain(props) {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  let { id } = useParams();
  const [officer,setOfficer] = useState("")
  const [goTo, setGoTo] = useState("upload-passport")

  
  let completedCount = 0

  useEffect(() => {
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        console.log("REMOVE");
        return null;
      }

      const application = async (token) => {
        const getApplication = await ApplicationByIdApi(token, id);

        if (getApplication.data) {
          console.log(getApplication.data.data);
          if (getApplication.data.data.status !== "CANCELLED") {
            if (getApplication.data.data.payment_status === "UNPAID") {
              toast.error(
                <span style={{ display: "flex", alignItems: "center" }}>
                  <BiError size="30" style={{ marginRight: "10px" }} />
                  Kindly Pay First!
                </span>,
                {
                  position: "bottom-left",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                  progress: undefined,
                }
              );
              setTimeout(() => {
                history.push(`/dashboard/transactions/payment/${id}`);
              }, 2000);
            } else {
              const valid = (getApplication.data.data.travellers_informations).every( function(val){ 
                return val.status === "COMPLETED"; 
              } )

              if(getApplication.data.data.travellers_informations.length !== 0){

                (getApplication.data.data.travellers_informations).map((value, index)=>{
                  if(value.status === "COMPLETED"){
                    completedCount += 1
                  }
                })

              if(valid === true && getApplication.data.data.travellers_informations.length >= getApplication.data.data.travellers_count){
                  toast.error(
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <BiError size="30" style={{ marginRight: "10px" }} />
                    This Application Was Already Completed!
                  </span>,
                  {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                  }
                );
                setTimeout(() => {
                  history.push(`/dashboard/my-applications`);
                }, 2000);
              }
              else if(getApplication.data.data.travellers_count === completedCount){
                toast.error(
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <BiError size="30" style={{ marginRight: "10px" }} />
                    This Application Was Already Completed!
                  </span>,
                  {
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                  }
                );
                setTimeout(() => {
                  history.push(`/dashboard/my-applications`);
                }, 2000);
              }
              else{

                if(getApplication.data.data.travellers_count > 1){
                  setLoading(false)
                  setGoTo("travellers")
                }

                if(getApplication.data.data.visa_officer.assigned_to === null){
                  setOfficer("")
                }
                else{
                  setOfficer(getApplication.data.data.visa_officer.assigned_to)
                }
                setLoading(false);
                props.ChangePassportDetails({
                id: id,
                application: true,
              })}
              }
              
             else if(getApplication.data.data.travellers_count > 1){
                setLoading(false)
                setGoTo("travellers")
              }
              else{
              if(getApplication.data.data.visa_officer.assigned_to === null){
                setOfficer("")
              }
              else{
                setOfficer(getApplication.data.data.visa_officer.assigned_to)
              }
              setLoading(false);
              props.ChangePassportDetails({
                id: id,
                application: true,
              })}
            }
          } else {
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                This Application Was Cancelled!
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
            setTimeout(() => {
              history.push("/dashboard/my-applications");
            }, 2000);
          }
        } else if (getApplication.error) {
          console.log(getApplication.error);

          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              Invalid Application!
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
          setTimeout(() => {
            history.push("/dashboard/my-applications");
          }, 2000);
        }
      };
      application(item.value.token);
    }
    getWithExpiry("userData");
  }, []);

  console.log(completedCount)

  return (
    <div className={styles.main}>
      {loading ? (
        <>
          <h2 className={styles.head}>Application Center</h2>
          <div className={styles.loader}>
            <div className="spinner-border" role="status"></div>
          </div>
        </>
      ) : (
        <>
          <h3 className={styles.head}>Application Center</h3>
          <div className={styles.mainBox}>
            <div className={styles.firstBox}>
              <h2 className={styles.firstBoxHead}>Virtual assistant</h2>
              <img src={eva} alt="Eva" className={styles.eva} />
              <p className={styles.firstBoxDes}>
                Meet Eva our 24/7 dedicated virtual assistant.
                <br />
                If you have any questions, chat
                <span className={styles.firstBoxClick}> here</span>
              </p>
              {/* <hr className={styles.line2} /> */}
              {
                (officer !== "") ?
                (
                  <div className={styles.firstBoxBottom}>
                  <div className={styles.firstBoxBottom1}>
                    <img
                      src={circle}
                      alt="Avatar"
                      className={styles.firstBoxImage}
                    />
                    <br />
                    {/* <br /> */}
                    <h2 className={styles.firstBoxName}>{officer}</h2>
                  </div>
                  <p className={styles.firstBoxDes2}>
                  {officer} is your assigned visa officer.
                    <br /> If you need any assistance kindly contact
                    <span className={styles.firstBoxClick}> here</span>
                  </p>
                  <div></div>
                </div>
                ) :
                (
                  <>
                  <div className={styles.firstBoxBottom}>
                  <br/>
                  <h2 className={styles.firstBoxName}>Assigned Visa Officer : <span className={styles.firstBoxDes2}>Not Assigned Yet!</span></h2>
                  </div>
                  </>
                )
              }
             
              {/* <hr className={styles.line2} /> */}
            </div>
            <div className={styles.secondBox}>
              <hr className={styles.line} />
            </div>
            <div className={styles.thirdBox}>
              <div className={styles.thirdBox2}>
                <h3 className={styles.thirdHead}>Visa requirements</h3>
                <h4 className={styles.thirdHead2}>Passport Data page</h4>
                <p className={styles.requirementDes2}>
                  <span className={styles.mark}></span>
                  <span className={styles.req2}>
                    We will request you to upload the scanned copy of your
                    international passport. Kindly upload a clear scan.
                  </span>
                </p>

                {/* <br /> */}
                <h4 className={styles.thirdHead2}>Passport Photograph</h4>
                <p className={styles.requirementDes2}>
                  <span className={styles.mark}></span>
                  <span className={styles.req2}>
                    A soft copy of your personal passport photograph is required
                    to complete the application.
                  </span>
                </p>
                {/* <br /> */}
                <span className={styles.noMobile}>
                  <h4 className={styles.thirdHead2}>Support service</h4>
                  <p className={styles.requirementDes2}>
                    <span className={styles.mark}></span>
                    <span className={styles.req2}>
                      Your visa officer is dedicated to your application and
                      hence available to assist you with any requrements. We
                      have also provided a comprehensive list of frequently
                      asked questions to assist you and if you need extra help,
                      Eva, our live virtual assistant is available to answer any
                      them.
                    </span>
                  </p>
                </span>
                <span className={styles.onlyMobile}>
                  <h4 className={styles.thirdHead2}>Dedicated Agent</h4>
                  <p className={styles.requirementDes2}>
                    <span className={styles.mark}></span>
                    <span className={styles.req2}>
                      <b>Visa Officer :</b>{" "}
                      <span className={styles.agent}> {((officer === "")? ("Not Assigned Yet"): (officer))}</span>
                    </span>
                  </p>
                </span>
              </div>
            </div>
          </div>
          <div className={styles.lastBtnCont}>
            <Link to={`/dashboard/my-applications/${id}/${goTo}`}>
            <button className={styles.lastBtn}>Start application</button>
            </Link>
          </div>
        </>
      )}
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
      />
    </div>
  );
}


const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) => dispatch(changePassportDetails(passportDetails)),
});

export default connect(mapStateToProps, mapDispatchToProp)(ApplicationCenterMain);